import { Box, styled } from "@mui/material";

export const StyledMaterialTable = styled(Box)(({ theme }) => ({
  width: "100%",
  maxHeight: "100%",
  height: "80%",
  overflowY: "scroll",
  position:"relative",
  ".header": {
    display: "flex",
    background: theme.color.main,
    color: theme.color.background,
    justifyContent: "space-between",
    padding: ".5rem 1rem",
  },
  ".content": {
    display: "flex",
    flexDirection: "column",
    ".row > *": {
      flex: "0 0 auto",
      overflow: "hidden",
    },
    ".row": {
      display: "flex",
      justifyContent: "space-between",
      padding: ".5rem 1rem",
      alignItems: "center",
      "& .MuiInputBase-root": {
        width: "100%",
        border: `2px solid ${theme.color.dark}`,
        flex: "1 1 0",
        color: theme.color?.dark || theme.palette.text.primary,
      },
      "& .MuiInputBase-input": {
        padding: ".25rem !important",
        width: "100%",
      },
      "& .MuiInput-underline:before, & .MuiInput-underline:after": {
        display: "none",
      },
    },
    ".addBtn": {
      justifyContent: "center",
      gap: "1rem",
      h4: {
        fontWeight: "bold",
      },
    },
    "& > *:nth-child(odd)": {
      background: theme.contrast.lighter,
    },
  },
  ".id": {
    width: "2%",
    textAlign: "center",
  },
  ".brand": {
    width: "15%",
    textAlign: "start",
    display: "flex",
  },
  ".material": {
    width: "30%",
  },
  ".netprice, .grossprice": {
    width: "10%",
    textAlign: "center",
    input: {
      textAlign: "center",
    },
  },
  ".stock": {
    width: "20%",
    textAlign: "center",
    display: "flex",
    justifyContent: "center",
    gap: "1rem",
    alignItems: "center",
    input: {
      textAlign: "center",
    },
  },
  ".actions": {
    width: "8%",
    textAlign: "center",
    diusplay: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
}));
